<template>
    <div class="product-parts">
        <ul>
            <li v-for="(part, idx) in parts">
                <a href="javascript:void(0);" @click="select(idx)" :class="{ 'icon-selected': isPartSelected(idx) }">
                    <span class="icon-holder">
                        <span :class="'icon ' + part.icon"></span>
                        <span class="error-badge" v-if="!isPartAvailable(part.depth) && !isDesktop"></span>
                    </span>
                    <span class="part-name">{{ part.name }}</span>
                    <span class="selected-part" v-if="isDesktop">{{ getPartName(part.depth) }}</span>
                    <span class="error-message" v-if="!isPartAvailable(part.depth) && isDesktop">{{ resources.notInStockLong }}</span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script src="./product-parts.js"></script>
